import { buildFontDeclarationsForBrand } from "../nibLegacy";
export var GuFonts = buildFontDeclarationsForBrand("gu");